/* eslint-disable react-hooks/exhaustive-deps */
import { IState, useMainStore } from "@/settings/zustand"
import { ButtonGroup, Card, ProgressBar } from "@blueprintjs/core"
import { ID } from "@libs/interfaces/layouts"
import { useEffect } from "react"
import { Navigate, Route, Routes, useNavigate } from "react-router"
import { __ } from "src/libs/utilities"
import { IFestStatistics, useFestStatistic } from "../../data/store"
import { useFestival } from "../../hooks/festival"
import { useStatistics } from "../../hooks/useStatistics"
import BackLink from "./BackLink"
import { ChooseForm, IFestStatisticsProps } from "./FestStatisticForm"
import FullExpertStatistics from "./FullExpertStatistics"
import FullMemberStatistics from "./FullMemberStatistics"
import SchoolsForm from "./SchoolsForm"
import SpecialStatistics from "./SpecialStatistics"
import StatisticForm from "./StatisticForm"
import Synthesizer from "./Synthesizer"

const MainStatisticForm = ( props: IFestStatisticsProps ) : JSX.Element => { 
    const navigate      = useNavigate()
    const festId: ID    = useMainStore((state: IState) => state.landId)
    const setSelected   = useFestStatistic(( state:IFestStatistics ) => state.setSelected )
    const isLoading     = useFestival(true, festId) 
    const stats         = useStatistics()   

    useEffect(() => {
        setSelected( [] )
        const layout_header = document.getElementById("layout-header")
        if(layout_header) layout_header.style.display  = "none"
        const layout_footer: HTMLDivElement | null = document.querySelector(".layout-footer-container")
        if(layout_footer) layout_footer.style.display  = "none"
        return () => {
            const layout_header = document.getElementById("layout-header")
            if(layout_header) layout_header.style.display  = "flex"
            const layout_footer: HTMLDivElement | null = document.querySelector("layout-footer-container")
            if(layout_footer) layout_footer.style.display  = "block"
        }
    }, [])  
    if( !stats.isLoading || isLoading ) { 
        const full      = 2 + stats.queueFull + 1
        const current   = stats.phase + stats.queueProjects 
        return <div className="layout-app-state flex-centered">
            <Card style={{ maxWidth: 400, padding: 50, width: "100%" }}>
                <div className="letter-spacing-1 text-lowercase mb-3">
                    { __( "Loading festival data" ) }
                </div>
                <ProgressBar value={ current / full } />
                <ButtonGroup fill variant="minimal" className="mt-3">
                    <BackLink intent="none" />
                </ButtonGroup>
            </Card>
        </div>
    }

    const goto = (url: string) => {
        navigate( url )
    }
    return <>  
        <Routes> 
            <Route path="" element={ <StatisticForm /> } >              
                {/* <Route index element={ <Navigate to="specials" replace /> } />    */}
                <Route index element={ <ChooseForm /> } />   
                <Route 
                    path="all-members" 
                    element={ 
                        <FullMemberStatistics 
                            members={ stats.projects } 
                            users={stats.users}
                            ratings={stats.ratings}
                            goto={goto}
                        /> 
                    } 
                />
                <Route 
                    path="users" 
                    element={ 
                        <FullExpertStatistics
                            members={ stats.projects } 
                            users={stats.users}
                            ratings={stats.ratings}
                            goto={goto} 
                        />
                    } 
                />
                <Route 
                    path="synthesizer" 
                    element={ 
                        <Synthesizer
                            members={ stats.projects } 
                            users={stats.users}
                            ratings={stats.ratings}
                            goto={goto}
                        />
                    } 
                />
                <Route 
                    path="specials" 
                    element={ 
                        <SpecialStatistics
                            members={ stats.projects } 
                            users={stats.users}
                            ratings={stats.ratings} 
                            goto={goto}
                        />
                    } 
                />                                             
                <Route 
                    path="schools" 
                    element={ 
                        <SchoolsForm 
                            members={ stats.projects }  
                            goto={goto} 
                        />
                    } 
                />                                             
                <Route path="*" element={ <Navigate to="specials" replace /> } />                                             
            </Route> 
        </Routes>
    </>
} 
export default MainStatisticForm